import OrderableModel from '@/models/OrderableModel';
import store from '@/store';

export default class TicketSource extends OrderableModel {
    get route () {
        return 'ticket-sources';
    }

    static get className () {
        return 'TicketSource';
    }

    static get isInStore () {
        return true;
    }

    static getIdByType (type) {
        const source = store.getters.getFilteredValue('ticketSources', (status) => {
            return status.internal_type === type;
        });
        return source ? source.id : null;
    }
}
